<template>
  <hb-section :title="title" :subtitle="subtitle" class="performance-strip">
    <div class="performance-strip__grid">
      <hb-metric :label="$t('influencer_panel.clicks')" :delta="delta('clicks')">
        {{ number(metrics.clicks) }}
      </hb-metric>

      <hb-metric :label="$t('influencer_panel.conversions')" :delta="delta('conversions')">
        {{ number(metrics.conversions) }}
      </hb-metric>

      <!-- Conversao ja e percentual: comparar em % de % engana, entao a variacao vai em
           pontos percentuais. -->
      <hb-metric
        :label="$t('influencer_panel.conversion_rate')"
        :delta="conversionDelta"
        unit="pp"
      >
        {{ percent(metrics.conversion_rate) }}
      </hb-metric>

      <hb-metric :label="$t('influencer_panel.gmv')" :delta="delta('gmv_cents')">
        <hb-money :cents="metrics.gmv_cents" />
      </hb-metric>

      <hb-metric :label="$t('influencer_panel.commission')" :delta="delta('commission_total_cents')">
        <hb-money :cents="metrics.commission_total_cents" />
      </hb-metric>

      <hb-metric :label="$t('influencer_panel.avg_ticket')" :delta="delta('avg_ticket_cents')">
        <hb-money :cents="metrics.avg_ticket_cents" />
      </hb-metric>
    </div>

    <p v-if="metrics.clicks_source === 'lifetime'" class="performance-strip__note">
      <feather-icon icon="InfoIcon" size="13" />
      {{ $t('influencer_panel.period_all_clicks_hint') }}
    </p>
  </hb-section>
</template>

<script>
import HbSection from '@/components/hubee/HbSection.vue'
import HbMetric from '@/components/hubee/HbMetric.vue'
import HbMoney from '@/components/hubee/HbMoney.vue'
import { deltaPercent } from '../panel'

/**
 * As seis metricas do periodo, com a variacao contra o periodo anterior.
 *
 * Sem `previous` (que e o caso de "desde o inicio") nenhuma seta aparece: nao ha janela
 * anterior com que comparar, e desenhar 0% seria inventar uma estabilidade que ninguem
 * mediu.
 */
export default {
  name: 'PerformanceStrip',
  components: { HbSection, HbMetric, HbMoney },
  props: {
    metrics: { type: Object, required: true },
    previous: { type: Object, default: null },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
  computed: {
    conversionDelta() {
      if (!this.previous) return null

      return Number(this.metrics.conversion_rate) - Number(this.previous.conversion_rate)
    },
  },
  methods: {
    delta(key) {
      if (!this.previous) return null

      return deltaPercent(this.metrics[key], this.previous[key])
    },
    number(value) {
      return Number(value || 0).toLocaleString('pt-BR')
    },
    percent(value) {
      return `${Number(value || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
    },
  },
}
</script>

<style scoped>
/*
  Grade de fio de cabelo: o `gap: 1px` sobre um fundo da cor da borda desenha as
  divisorias sem cada celula precisar de border e sem dobrar a linha entre vizinhas.
*/
.performance-strip__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1px;
  background: var(--border-color);
  border-radius: var(--radius);
  overflow: hidden;
}

.performance-strip__note {
  margin: 0.85rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
</style>
